import React, { useState, useEffect } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Button from "@mui/material/Button";
import RotatingSpinner from "../Resourses/RotatingSpinner";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { getUserInfo } from "../Authservice";
import axios from "axios";
import { resources } from "../Resourses/Resources";
import DialogActions from "@mui/material/DialogActions";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";
import { PageHeader } from "../Header/PageHeader";
const errorMessage = (message) => {
  toast.error(message, {
    toastId: "error1",
    className: "error",
  });
};

const successMessage = (message) => {
  toast.success(message, {
    toastId: "success1",
    className: "success",
  });
};

const Naac = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const user = getUserInfo()?.roles[0];
  const [openDialog, setOpenDialog] = useState(false);
  const [filePreview, setFilePreview] = useState("");
  const [status,setStatus]=useState(true);

 

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        resources.APPLICATION_URL + "getNacCriteria"
      );
      if(response.data){
        setStatus(false);
        setData(response.data);
      }
     
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const saveData = async () => {
    try {
      const formData = new FormData();
      filesToUpload.forEach((file, index) => {
        formData.append("file", file);
      });
      const jsonBlob = new Blob([JSON.stringify(data)], {
        type: "application/json",
      });
      formData.append("eventData", jsonBlob);

      const res = await axios.post(
        resources.APPLICATION_URL + "saveNacCriteria",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (res.status == 200) {
        fetchData();
        successMessage("Data saved successfully!");
      }
    } catch (error) {
      console.error("Error saving data", error);
    }
  };

  const handleTextChange = (e, path) => {
    const newData = [...data];
    path.reduce((acc, curr, i) => {
      if (i === path.length - 1) {
        acc[curr] = e.target.innerText;
      }
      return acc[curr];
    }, newData);
    setData(newData);
  };

  const handleFileUpload = (e, criteriaIndex, subIndex, nestedIndex) => {
    const file = e.target.files[0];
    if (file) {
      setFilesToUpload([...filesToUpload, file]);
      const newData = [...data];
      newData[criteriaIndex].nacChildCriteria[subIndex].nacSubChildCriteria[
        nestedIndex
      ].fileName = file.name;
      setData(newData);
    }
  };

  const addCriteria = () => {
    setData([...data, { criteriaName: "New Criteria", nacChildCriteria: [] }]);
  };

  const removeCriteria = (index) => {
   
      setData(data.filter((_, i) => i !== index));
  
    
  };

  const addSubCriteria = (index) => {
    const newData = [...data];
    newData[index].nacChildCriteria.push({
      criteriaCName: "New Sub-Criteria",
      nacSubChildCriteria: [],
    });
    setData(newData);
  };

  const removeSubCriteria = (criteriaIndex, subIndex) => {
    const newData = [...data];
    newData[criteriaIndex].nacChildCriteria.splice(subIndex, 1);
    setData(newData);
  };

  const addNestedSubCriteria = (criteriaIndex, subIndex) => {
    const newData = [...data];
    newData[criteriaIndex].nacChildCriteria[subIndex].nacSubChildCriteria.push({
      criteriaSCName: "New Nested Sub-Criteria",
      fileName: "",
    });
    setData(newData);
  };

  const removeNestedSubCriteria = (criteriaIndex, subIndex, nestedIndex) => {
    const newData = [...data];
    newData[criteriaIndex].nacChildCriteria[
      subIndex
    ].nacSubChildCriteria.splice(nestedIndex, 1);
    setData(newData);
  };
    const handleFileView = async (filePath) => {
    try {
      const response = await axios.get(resources.APPLICATION_URL + "getDocumentView", {
        params: { filePath },
      });
      setFilePreview(response.data);
 
      setOpenDialog(true);
      // console.log("Base64 Data:", response.data);
    } catch (error) {
      console.error("Error fetching file", error);
    }
  };
  const deleteC=async(id)=>{
    // if (!status) {
    //   console.log("!statusss", status)
    //   return;
    // }
    try {
      const res=await axios.delete(resources.APPLICATION_URL+"deleteNacParent?uniqueKey="+id)
     if (res.data) {
      successMessage("Criteria Successfully deleted");
      fetchData();
     }else{
      errorMessage("Deleting Criteria Fail")
     } 
    } catch (error) {
      
    }
  }
  const deletenSubC=async(id)=>{
    if (!status) {
      return;
    }
    try {
      const res=await axios.delete(resources.APPLICATION_URL+"deleteNacChild?uniqueKey="+id)
      if (res.data) {
       successMessage("Sub-Criteria Successfully deleted");
       fetchData();
      }else{
       errorMessage("Sub-Deleting Criteria Fail")
      } 
    } catch (error) {
      
    }
  }
  const deleteNested=async(id)=>{
    if (!status) {
      return;
    }
    try {
      const res=await axios.delete(resources.APPLICATION_URL+"deleteNacSubChild?uniqueKey="+id)
      if (res.data) {
       successMessage("Child-Criteria Successfully deleted");
       fetchData();
      }else{
       errorMessage("Child-Deleting Criteria Fail")
      } 
    } catch (error) {  
    }
  }

  return (
    <>
      {isLoading ? (
        <RotatingSpinner />
      ) : (
        <div className="container mt-5">
           <PageHeader name={"NAAC SSR REPORT"} />
          {user === "ROLE_MANAGEMENT" && (
            <>
              {" "}
              <Button variant="contained" onClick={addCriteria}>
                Add Criteria
              </Button>
              <Button
                variant="contained"
                color="success"
                onClick={saveData}
                style={{ marginLeft: "10px" }}
              >
                Save
              </Button>
            </>
          )}
          <div className="crt_main">
            {data.map((each, index) => (
              <Accordion key={index} className="naac_ssr_criterias">
                <AccordionSummary expandIcon={<ArrowDropDownIcon />}>
                  <Typography
                    contentEditable={user==="ROLE_MANAGEMENT"}
                    suppressContentEditableWarning
                    onBlur={(e) => handleTextChange(e, [index, "criteriaName"])}
                  >
                    {each.criteriaName}
                  </Typography>
                  &nbsp;
                  {user==="ROLE_MANAGEMENT" &&(
                  <Button
                     variant="outlined"
                    color="error"
                    onClick={() => {
                      // removeCriteria(index);
                      deleteC(each.uniqueKey)
                    }}
                  >
                   <DeleteIcon />
                  </Button>)}
                </AccordionSummary>
                <AccordionDetails>   
                &nbsp; {user==="ROLE_MANAGEMENT" &&(
                  <Button
                    variant="outlined"
                    onClick={() => addSubCriteria(index)}
                  >
                     <AddIcon/>
                  </Button>)}
                  {each.nacChildCriteria.map((sub, i) => (
                    <Accordion key={i} className="naac_ssr_inside">
                      <AccordionSummary expandIcon={<ArrowDropDownIcon />}>
                        <Typography
                          contentEditable={user==="ROLE_MANAGEMENT"}
                          suppressContentEditableWarning
                          onBlur={(e) =>
                            handleTextChange(e, [
                              index,
                              "nacChildCriteria",
                              i,
                              "criteriaCName",
                            ])
                          }
                        >
                          {sub.criteriaCName}
                        </Typography>
                        &nbsp;{user==="ROLE_MANAGEMENT" &&(
                        <Button
                          variant="outlined"
                          color="error"
                          onClick={() =>{ removeSubCriteria(index, i)
                            deletenSubC(sub.uniqueKey)
                          }}
                        >
                         <DeleteIcon />
                        </Button>)}
                      </AccordionSummary>
                      <AccordionDetails>
                      &nbsp; {user==="ROLE_MANAGEMENT" &&(
                        <Button
                          variant="outlined"
                          onClick={() => addNestedSubCriteria(index, i)}
                        >
                         <AddIcon/>
                        </Button>)}
                        {sub.nacSubChildCriteria.map((nested, id) => (
                          <AccordionDetails key={id}>
                            <AccordionSummary expandIcon={<VisibilityIcon  onClick={() => handleFileView(nested.filePath)}/>}  >
                              <Typography
                                contentEditable={user=="ROLE_MANAGEMENT"}
                                suppressContentEditableWarning
                                onBlur={(e) =>
                                  handleTextChange(e, [
                                    index,
                                    "nacChildCriteria",
                                    i,
                                    "nacSubChildCriteria",
                                    id,
                                    "criteriaSCName",
                                  ])
                                }
                              >
                                {nested.criteriaSCName}
                              </Typography>
                              &nbsp;  {user==="ROLE_MANAGEMENT" &&(
                              <input
                                type="file"
                                onChange={(e) =>
                                  handleFileUpload(e, index, i, id)
                                }
                              />)}
                              {/* <Typography>{nested.fileName}</Typography> */}
                              &nbsp;  {user==="ROLE_MANAGEMENT" &&( <Button
                                variant="outlined"
                                color="error"
                                onClick={() =>{
                                  removeNestedSubCriteria(index, i, id);
                                  deleteNested(nested.uniqueKey);
                                }
                                }
                              >
                              <DeleteIcon />
                              </Button>)}
                            </AccordionSummary>
                          </AccordionDetails>
                        ))}
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
          <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="l" fullWidth>
        <DialogTitle>View File</DialogTitle>
        <DialogContent>
          {filePreview.startsWith("JVBER") ? (
            <iframe src={`data:application/pdf;base64,${filePreview}`} width="100%" height="500px"></iframe>
          ) : (
            <img src={`data:image/png;base64,${filePreview}`} alt="Preview" style={{ width: "100%" }} />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}  variant="contained"  color="error">Close</Button>
        </DialogActions>

      </Dialog>
        </div>
      )}
    </>
  );
};

export default Naac;

